import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonDirective, ButtonLabel} from 'primeng/button';
import {
  resolveAnomalyPolygonColor,
  translateKeyForAnomalyType,
} from '@app/pages/crop-monitoring/pages/anomalies/anomaly-type-colors';

/**
 * One anomaly card in the field details sidebar (type, detection date, “show on map”).
 */
@Component({
  selector: 'app-field-details-anomaly-row',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonDirective, ButtonLabel],
  templateUrl: './field-details-anomaly-row.component.html',
  styleUrls: ['./field-details-anomaly-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldDetailsAnomalyRowComponent {
  @Input({ required: true }) row!: any;
  @Output() showOnMap = new EventEmitter<void>();

  anomalyColor(): string {
    return resolveAnomalyPolygonColor(this.row);
  }

  anomalyTypeKey(): string {
    const t = this.row?.anomalyType ?? this.row?.anomalyPolygon?.anomalyType;
    return translateKeyForAnomalyType(t) || '';
  }

  anomalyDetectionDate(): string | Date | null {
    return this.row?.anomalyPolygon?.originalDate ?? this.row?.originalDate ?? null;
  }

  onShowOnMap(): void {
    this.showOnMap.emit();
  }
}
